import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import Header from'../Component/Header'
const Registration = () => { 
  useEffect(() => {
    document.title = ' Registration - St. Josephs School Quadian Punjab';  
}, []); 
  return (
     <> 
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Admission</li>
                 <li>Registration</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2>Registration</h2>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12"> 
                     <p>Those who wish to admit their children in this school must buy the prospectus of the school and study in detail the terms and conditions of the admission process and the subsequent code of conduct for the parents and the students to be followed if admission is granted. </p> <p>The prospectus is available at the reception counter of the school for the parents to buy. </p> <p>All prospective candidates for any class must get their names registered at the school office. The dates of registration shall be intimated through the Principal's circular. No registration shall be made prior to the dates specified. </p> <p>Initially Registration Forms will be disbursed for admission to Kindergarten (Nursery class) along with the prospectus. </p> <p>Anyone is free to collect the Registration Form from the school office along with the Prospectus within the announced period of time by paying the charges for the Form and the prospectus. Registration Charges, the cost of the Form and prospectus are not refundable. </p> <p>After having thoroughly studied the terms and conditions inscribed in the prospectus, those who wish to seek admission of their child to this school may fill up the Registration Form and submit it to the office within the specified period of time along with the required preliminary documents and Registration fee. The Registration Fee is not refundable. </p> <p>The school will examine the Registration Forms, and the eligible applicants as per the terms and conditions mentioned in the registration form will be invited to be present for the drawing of lots, if there are too many applicants on the fray. </p> <p>Availability of vacant seats to higher classes would be very scarce, as it is very rare that any student leaves the school once taken the admission. Registration date for filling the vacant seats in higher classes may be informed to those who enquire from the school office. </p>
                     </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default Registration

